var viewer_rtlignore_default = {
  "gallery_container": "jQQBk",
  "imageTitleContainer": "_62Mxs",
  "clickableItem": "Irv9k",
  "prerender": "_26xPE",
  "expandButton": "y9f3j",
  "itemContainer": "_-9AIX",
  "expandIcon": "uzeia",
  "itemOverlay": "VdChz",
  "imageTitle": "z5ZWa",
  "pointer": "wMqKU",
  "fadeIn": "OD871",
  "changing_background": "bB55H"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
